import React from 'react';

import "./css/CoolLoader2.css";
import {getArr} from "./baseFunctions";
//import world from "./images/world-map5.svg";
class CoolLoader2 extends React.Component {
	constructor(){
		super();
		this.randomData = this.randomData.bind(this);
	}
	randomData(){
		return Math.round((Math.random()*200));
	}
	componentWillReceiveProps(nextProps)
	{
		if(nextProps.show !== this.props.show)
		{
			if(this.int)
			{
				clearInterval(this.int);
			}
			if(this.myLine)
			{
				this.myLine.destroy();
			}
		}
	}
	componentDidMount(){
		if(this.props.type === "lineGraph")
		{
			var ctx = this.refs.canvas;
			this.config = {
				animation: true,
				animationEasing: "easeOutBack",
	        type: 'line',
	        data: {
	            labels: getArr(6).map(() => this.randomData().toString()),
	            datasets: [{
	                label: "",
	                backgroundColor: 'rgba(42, 63, 84, 0.74)',
	                borderColor: 'rgba(42, 63, 84, 0.74)',
	                data: getArr(6).map(() => this.randomData()),
	            }]
	        },
	        options: {
				    legend: {
				        display: false
				    },
				  }
	    };
	    console.log("Data", this.config, this.config.data.labels.length);
			this.myLine = new window.Chart(ctx, this.config);
			this.int = setInterval(() => {
				var me = this;
				this.config.data.datasets.forEach(function(dataset) {
					dataset.data.forEach(function(dataObj, j) {
						if (typeof dataObj === 'object') {
							dataObj.y = me.randomData();
						} else {
							dataset.data[j] = me.randomData();
						}
					});
				});
				this.myLine.update();
			}, 900);
		}
	}
	render(){
		if(!this.props.show)
		{
			return false;
		}
		if(this.props.type === "lineGraph")
		{
			return (<canvas ref="canvas" className="lineCanvas" height={this.props.height} width={this.props.width} id="canvas"></canvas>);
		}
		const data = {
			"table": 10,
			"graph": 47,
		};
		var world = require("./images/world-map5.svg");
		return (<div className={"animated-background2 " + this.props.type} style={this.props.style || {}}>
              <div className="background-masker2 header-top2"></div>
              {
              	this.props.type === "worldMap" ? <img src={world} className="map"/> : ""
              }
              
              {
                getArr(data[this.props.type]).map((d, key) => <div key={"line" + key} className={"background-masker2 line2-" + (key + 1)}></div>)
              }
           </div>);
	}
}

export default CoolLoader2;


// WEBPACK FOOTER //
// ./src/components/CoolLoader2.js